module.exports = __webpack_public_path__ + "static/media/chef-dish.88248c1a.png";